$graph = $('.js-graph');

function show() {
  var w = $(window).width();
  if (w > 767) {
    $('.js-graph-target').hide();
  } else {
    $('.js-graph-target:not(:first-of-type)').hide();
    $('.js-graph-target:first-of-type').show();
  }
}
if ($graph.length) {
  $graph.load('//cdn.shopify.com/s/files/1/0555/6283/0018/t/1/assets/graph3.html', function() {
    show();
    $('[data-graph]').hover(function() {
      data = $(this).data('graph');
      var w = $(window).width();
      if (w <= 767) {
        $('.js-graph-target').fadeOut();
      }
      $(data).stop().fadeToggle();
    });
  });
}